import {useContext} from "react";
import {ZonesContext, LabelsContext} from "../AppContext";

function Prices(props) {
    const maxZones = 7;
    const zonesState = useContext(ZonesContext);
    const labelsState = useContext(LabelsContext);
    const numberOfZones = Object.entries(zonesState.selectedZones).length;
    const product = props.product;
    const firstRow = props.product.rows[0];
    const numberOfColumns = firstRow.columns.length;
    groupRowsByColumn(product.rows);

    function formatPrice(price) {
        if (price === 0) {
            return '-';
        } else if (price.toString().includes('.')) {
            return price + '0'
        } else {
            return price + (parseInt(price) === price ? '.-' : '');
        }
    }

    function getPriceByNumberOfZones(prices) {
        const priceByZone = prices.filter((price) => {
            return numberOfZones === price.numberOfZones || (numberOfZones > maxZones && price.numberOfZones === maxZones);
        })[0];
        return (
            <>
                <td>{formatPrice(priceByZone.secondClass)}</td>
                <td>{formatPrice(priceByZone.firstClass)}</td>
            </>
        )
    }

    /**
     * Group rows by columns for mobile view
     * @param rows
     * @returns {{}}
     */
    function groupRowsByColumn(rows) {
        let columns = {};
        Object.entries(rows).map(([index, row]) => {
            Object.entries(row.columns).map(([index, column]) => {
                if (typeof columns[btoa(column.title)] === 'undefined') {
                    columns[btoa(column.title)] = {
                        title: column.title,
                        rows: []
                    };
                }
                columns[btoa(column.title)].rows.push({
                    prices: column.prices,
                    title: row.title
                });
            });
        });

        return columns;
    }

    return (
        numberOfZones > 0
            ?
            <div className="prices-wrapper">
                <div className={'desktop'}>
                    <table className={'table table-frimobil'}>
                        <thead>
                        <tr>
                            <th rowSpan={2}></th>
                            {
                                Object.entries(firstRow.columns).map(([index, column]) => {
                                    if (parseInt(index) + 1 <= numberOfColumns) {
                                        const columnTitle = column.title.split('|')

                                        return (
                                            <th colSpan={2}>
                                                {columnTitle.map((text) => (
                                                    <span>{text}</span>
                                                ))}
                                            </th>
                                        )
                                    }
                                })
                            }
                        </tr>
                        <tr>
                            {
                                Object.entries(firstRow.columns).map(([index, column]) => {
                                    if (parseInt(index) + 1 <= numberOfColumns) {
                                        return (
                                            <>
                                                <th dangerouslySetInnerHTML={{__html: labelsState.getLabel('tx_mrfrimobilprices_domain_model_price.second_class')}}></th>
                                                <th dangerouslySetInnerHTML={{__html: labelsState.getLabel('tx_mrfrimobilprices_domain_model_price.first_class')}}></th>
                                            </>
                                        )
                                    }
                                })
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            Object.entries(product.rows).map(([index, row]) => {
                                const rowTitle = row.title.split('|')

                                return <tr>
                                    <td>
                                        {rowTitle.map((text) => (
                                            <span>{text}</span>
                                        ))}
                                    </td>
                                    {
                                        Object.entries(row.columns).map(([index, column]) => {
                                            if (parseInt(index) + 1 <= numberOfColumns) {
                                                return (
                                                    <>
                                                        {
                                                            getPriceByNumberOfZones(column.prices)
                                                        }
                                                    </>
                                                )
                                            }
                                        })
                                    }
                                </tr>
                            })
                        }
                        </tbody>
                    </table>
                </div>
                <div className={'mobile'}>
                    {
                        Object.entries(groupRowsByColumn(product.rows)).map(([index, column]) => {
                            const columnTitle = column.title.split('|')

                            return <table className={'table table-frimobil'}>
                                <thead>
                                <tr>
                                    <th rowSpan={2}></th>
                                    <th colSpan={2}>
                                        {columnTitle.map((text) => (
                                          <span>{text}</span>
                                        ))}
                                    </th>
                                </tr>
                                <tr>
                                    {
                                        <>
                                            <th dangerouslySetInnerHTML={{__html: labelsState.getLabel('tx_mrfrimobilprices_domain_model_price.second_class')}}></th>
                                            <th dangerouslySetInnerHTML={{__html: labelsState.getLabel('tx_mrfrimobilprices_domain_model_price.first_class')}}></th>
                                        </>
                                    }
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    Object.entries(column.rows).map(([index, row]) => {
                                        const rowTitle = row.title.split('|')

                                        return <tr>
                                            <td>
                                                {rowTitle.map((text) => (
                                                    <span>{text}</span>
                                                ))}
                                            </td>
                                            {
                                                getPriceByNumberOfZones(row.prices)
                                            }
                                        </tr>
                                    })
                                }
                                </tbody>
                            </table>
                        })
                    }
                </div>
            </div>
            : ''
    )
}

export default Prices;
